module.exports = __webpack_public_path__ + "img/sa.846c745f.png";